"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ParallelTransform = void 0;
exports.parallel = parallel;
var _nodeStream = _interopRequireWildcard(require("node:stream"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
class ParallelTransform extends _nodeStream.Transform {
  constructor(transformFn, concurrency, options = {}) {
    // Sanitize concurrency
    concurrency = parseInt(concurrency);
    if (isNaN(concurrency)) {
      throw new RangeError(`concurrency must be a number`);
    }
    if (concurrency < 1) {
      throw new RangeError(`concurrency must be at least 1`);
    }
    // Sanitize options
    options ??= {};
    if (options.objectMode !== false) {
      options.objectMode = true;
    }
    if (!options.highWaterMark) {
      options.highWaterMark = Math.max(2 * concurrency - 1, _nodeStream.default.getDefaultHighWaterMark(options.objectMode));
    }
    super(options);
    this.flushed = false;
    this.buffer = [];
    this.concurrency = concurrency;
    this.transformFn = transformFn;
    this.waterMark = 0;
  }
  async callTransformFn(value) {
    try {
      const result = await this.transformFn(value);
      if (!this.destroyed) {
        this.buffer.push(result);
        this._drain();
      }
    } catch (err) {
      this.emit("error", err);
      if (!this.destroyed) {
        this.push(null);
        this.destroy();
      }
    }
  }
  _drain() {
    while (this.buffer.length > 0) {
      const result = this.buffer.pop();
      --this.waterMark;
      if (result !== null) {
        this.push(result);
      }
    }
    const drained = this.flushed ? this.waterMark == 0 : this.waterMark < this.concurrency;
    if (drained && this.drainFn) {
      const drainFn = this.drainFn;
      this.drainFn = undefined;
      drainFn();
    }
  }
  _flush(callback) {
    this.flushed = true;
    this.drainFn = callback;
    this._drain();
  }
  _transform(value, _encoding, callback) {
    ++this.waterMark;
    this.callTransformFn(value);
    if (this.waterMark < this.concurrency) {
      callback();
    } else {
      this.drainFn = callback;
    }
  }
}
exports.ParallelTransform = ParallelTransform;
function parallel(transformFn, concurrency) {
  return new ParallelTransform(transformFn, concurrency);
}